module.exports = __webpack_public_path__ + "img/qq-square.390df74b.svg";